/* Autogenerated file. Do not modify */
define([], function() {
    'use strict';
    var skins = {};
     skins['wysiwyg.common.components.spotifyplayer.viewer.skins.SpotifyPlayerSkin'] = {
  "react": [
    [
      "iframe",
      "iframe",
      [],
      {
        "scrolling": "no",
        "frameBorder": 0,
        "allowtransparency": "true"
      }
    ],
    [
      "div",
      "placeholder",
      [
        "_hidden"
      ],
      {}
    ]
  ],
  "params": {
    "webThemeDir": "URL"
  },
  "paramsDefaults": {
    "webThemeDir": "WEB_THEME_DIRECTORY"
  },
  "css": {
    "%iframe": "overflow:hidden;",
    "%placeholder": "width:300px;height:80px;background:transparent url([webThemeDir]spotify/placeholder.png) 0 0 no-repeat;"
  }
}

    return skins;
});
